module.exports = __webpack_public_path__ + "static/media/gtLogo2.825144be.png";